import urls from 'urls';
import {apiClient} from '~/api/api-client';
import {saveEventThunk} from '~/CreateFabricInvitation/api/event';
import {UPDATE_EVITE_EVENT} from '~/common/fabric/reducers/eviteEvent/constants';
import {centsToDollarDisplay} from '~/common/utils/payment_utils';
import {userLoggedIn} from '~library/organisms/LoginModal/reducer';
import {saveUserDataToLocalStorage} from '~library/utils/auth/utils';

export const removeOffer = async (store) => {
  const state = store.getState();
  const paymentType = state.review?.paymentType;
  const eventId = state.eviteEvent.id;
  if (!eventId) return; // Event has not been created yet; no event for API to reference

  const postData = {
    // biome-ignore lint/style/useNamingConvention: existing error
    event_id: eventId,
    // biome-ignore lint/style/useNamingConvention: existing error
    payment_type: paymentType,
  };

  const url = urls.get('ajax_downgrade');

  const resp = await apiClient.post(url, postData, {
    headers: {
      cache: 'no-cache',
      'Content-Type': 'application/json',
    },
  });
  const data = await resp.json();

  if (!resp.ok) {
    const error =
      data.message || 'Sorry there was an error - please wait a few minutes and try again';
    evite.error(error);
  }

  store.dispatch({
    type: UPDATE_EVITE_EVENT,
    payload: {
      // biome-ignore lint/style/useNamingConvention: existing error
      max_guest_list: data.event.max_guest_list,
      // biome-ignore lint/style/useNamingConvention: existing error
      custom_logo: data.event.custom_logo,
      // biome-ignore lint/style/useNamingConvention: existing error
      custom_logos: data.event.custom_logos,
      options: {
        offers: data.event.options.offers,
        downgraded: data.event.options.downgraded,
        // biome-ignore lint/style/useNamingConvention: existing error
        event_option_show_gifting: data.event.options.event_option_show_gifting,
        // biome-ignore lint/style/useNamingConvention: existing error
        event_option_enable_photo_sharing: data.event.options.event_option_enable_photo_sharing,
      },
    },
  });
};

export const updateUser = async (store) => {
  const url = urls.get('ajax_get_user');
  const resp = await apiClient.get(url, {cache: 'no-cache'});
  const data = await resp.json();
  saveUserDataToLocalStorage(data);
  await store.dispatch(
    userLoggedIn(
      data.user_id,
      data.full_name,
      data.subscription_plan_name,
      data.email,
      data.avatar_disk,
      data.image_url,
      data.initials,
      data.first_name
    )
  );
};

export const postPurchaseTasks = async (store, {invoiceLineItem, total}) => {
  store.dispatch(saveEventThunk(true));
  const invitationMakerFlow = /^\/invitation-maker/.test(window.location.href);
  window.dataLayer.push({
    event: `${invitationMakerFlow ? 'onestep_create' : 'fabric_create'}_transaction_complete`,
    // biome-ignore lint/style/useNamingConvention: existing error
    line_items: invoiceLineItem,
    total: centsToDollarDisplay(total, true, false),
    // biome-ignore lint/style/useNamingConvention: existing error
    is_fabric_premium: true,
    // biome-ignore lint/style/useNamingConvention: existing error
    tracking_product_type: window.tracking_product_type,
  });
  updateUser(store);
};
